import { Button } from '@mui/material'
import type React from 'react'
import type { ReactNode } from 'react'
import { useAuth } from '../hooks/useAuth'

type ExportButtonProps = {
  children: ReactNode
  title: string
  onExport: () => void
}

export const ExportButton: React.FC<ExportButtonProps> = props => {
  const onClickHandler = async () => {
    props.onExport()
  }
  const auth = useAuth()
  return (
    <>
      <Button
        disabled={auth.isDisable}
        onClick={onClickHandler}
        sx={{
          justifyContent: 'center',
          alignContent: 'center',
          color: '#FFFFFF',
          font: 'normal normal bold 21px/32px Noto Sans JP',
          backgroundColor: auth.isDisable ? '#CACACA' : '#282828',
          '&:hover': {
            backgroundColor: '#282828',
            opacity: 0.8,
          },
          boxShadow: '0px 2px 2px #00000014',
          height: '54px',
          width: '189px',
          borderRadius: '40px',
          mt: '10px',
        }}
      >
        {props.children}
      </Button>
    </>
  )
}
